// extracted by mini-css-extract-plugin
export default {"container":"a0-z","title":"b0-z","link":"c0-z"};